import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

// hooks.
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";

// components.
import { VIMModal } from "./components/VIMModal";
import { useGetVimInfoQuery } from "./services/get-vim.endpoints";
import { setHasVIM, setWasOpened } from "./slices/vim.slice";

export const VIMCard = () => {
  const dispatch = useDispatch();
  const { nid } = useParams();
  const { country } = useUserProfile();
  const [isOpen, setIsOpen] = useState(false);

  const {
    data: vimInfo,
    isLoading,
    isSuccess,
    isError,
  } = useGetVimInfoQuery({
    country: country || "",
    nid: Number(nid),
  });

  const hasInfo = vimInfo && Object.keys(vimInfo).length > 0;

  useEffect(() => {
    if (isLoading) {
      toast.loading("Cargando sugerencias de precio...", {
        toastId: "loadingVIM",
      });
    } else {
      toast.dismiss("loadingVIM");
    }
    if (isSuccess) {
      if (hasInfo) {
        dispatch(setHasVIM(hasInfo));
        toast.success("Sugerencias de precio disponibles");
      }
    }
    if (isError) {
      toast.error("Sin sugerencias de precio");
    }
  }, [isLoading, isSuccess, vimInfo, isError]);

  return (
    <>
      {isSuccess && hasInfo && (
        <div
          className="bonus-card d-flex justify-content-between"
          onClick={() => {
            setIsOpen(true);
            dispatch(setWasOpened(true));
          }}
        >
          <div className="fw-bold">VIM</div>
        </div>
      )}
      {hasInfo && (
        <VIMModal
          show={isOpen}
          onClose={() => setIsOpen(false)}
          dataVim={vimInfo}
        />
      )}
    </>
  );
};
